import type { ObjectParser } from ".";

export const defaultObjectParsers: ObjectParser[] = [];
